import { createFileRoute, redirect } from "@tanstack/react-router";

// /office/reports has no landing page yet — Order Overview is the first report.
export const Route = createFileRoute("/office/reports/")({
  beforeLoad: async () => {
    throw redirect({ to: "/office/reports/order-overview" });
  },
});
